export function callOnce<A extends unknown[], R>(func: (...args: A) => R): (...args: A) => R {
  let hasBeenCalled: boolean = false;
  let result: R;

  return (...args: A): R => {
    if (!hasBeenCalled) {
      hasBeenCalled = true;
      result = func(...args);
    }
    return result;
  };
}
